<template>
    <div>
        <div class="d-flex aling-items-center text-nowrap">
            <collar-status :code="$safe(current,'Code')" small :name="$safe(current,'Name')" :id="`ds-cs-${k}`"></collar-status>
        </div>
        <b-tooltip  :target='`ds-cs-${k}`' triggers="hover">
            <template v-for="(g,i) in collars">
                <hr v-if="i != 0" :key="'d'+i" class="my-25 py-0"/>
                <div class="px-50 py-25 text-left"  :key="i">
                    <b>Yaka: </b>{{$safe(g,'GarageName') || '-'}}<br/>
                    <b>Başlangıç Tarihi: </b>{{$safe(g,'StartDateStr') || '-'}}<br/>
                    <b>Bitiş Tarihi: </b>{{$safe(g,'EndDateStr') || '-'}}
                </div>
            </template>
        </b-tooltip>
    </div>
</template>

<script>
import { BTooltip } from 'bootstrap-vue'
import CollarStatus from '../../components/CollarStatus.vue'

export default {
    components:{
        BTooltip,
        CollarStatus
    },
    props:{
        collars:Array,
        k:Number
    },
    computed:{
        current(){
            return (this.collars || [])[0] || null
        }   
    }
}
</script>
